import React from 'react'
import { isMembershipType, notMembershipType } from '../helpers/logic'
import GroupedEventItem from './grouped-event-item'
import MembershipItem from './membership-item'
import { groupBy } from 'lodash-es'
import DateFormat from '../../shared/helpers/date-format'

const { fancyFull } = DateFormat

const GENERAL_ADMISSION_TITLE = 'Shedd Admission'

const customEventItemSort = (a, b) => {
  if (a.name == GENERAL_ADMISSION_TITLE) {
    return -1
  } else if (a.name > b.name) {
    return 1
  } else if (a.name < b.name) {
    return -1
  } else {
    return 0
  }
}

function CurrentCartSummary({ items }) {
  const eventItems = items.filter(notMembershipType)
  const membershipItems = items.filter(isMembershipType)

  const eventItemsSortedByDate = eventItems.slice().sort((a, b) => {
    if (a.occursAt > b.occursAt) {
      return 1
    } else if (a.occursAt < b.occursAt) {
      return -1
    } else {
      return 0
    }
  })

  const eventItemsGroupedByDate = groupBy(eventItemsSortedByDate, item =>
    fancyFull(item.occursAt)
  )

  const eventItemsGroupedByDateArray = Object.entries(
    eventItemsGroupedByDate
  ).slice()

  const eventItemsGroupedByDateAndSorted = eventItemsGroupedByDateArray.map(
    ([date, items]) => {
      const sortedItems = items.slice().sort(customEventItemSort)
      return [date, sortedItems]
    }
  )

  if (items.length > 0) {
    return (
      <div className="hidden md:block pl-12 pb-24 relative text-depths">
        {eventItemsGroupedByDateAndSorted.map(([date, items]) => (
          <GroupedEventItem
            items={items}
            date={date}
            key={date}
          />
        ))}
        {membershipItems.map(item => (
          <MembershipItem
            item={item}
            key={item.id}
          />
        ))}
      </div>
    )
  }
  return null
}

export default CurrentCartSummary
